import { render, staticRenderFns } from "./ResidentDirectory.vue?vue&type=template&id=480eddd7&scoped=true"
import script from "./ResidentDirectory.vue?vue&type=script&lang=js"
export * from "./ResidentDirectory.vue?vue&type=script&lang=js"
import style0 from "./ResidentDirectory.vue?vue&type=style&index=0&id=480eddd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480eddd7",
  null
  
)

export default component.exports